'use client'

import type { ReactNode } from 'react'
import Image from 'next/image'
import { LocaleAccessGate } from '@/components/i18n/LocaleAccessGate'
import { LocaleSwitcher } from '@/components/i18n/LocaleSwitcher'
import { Providers } from '../../providers'

// Focused layout for funnel-only landing pages (promo campaigns, /invite,
// /early-access): no MarketingNav, no Footer — the page's own CTA is the only
// path forward, and the logo is deliberately not a link. `Providers` is
// required: these pages (and SignUpModal/LocaleAccessGate) call `useAuth()`,
// which throws without an AuthProvider.
export default function FocusedLandingLayout({ children }: { children: ReactNode }) {
  return (
    <Providers>
      <LocaleAccessGate>
        <div className="flex min-h-screen flex-col bg-black text-white">
          <div className="fixed start-6 top-6 z-50 flex h-9 w-28 items-center justify-center md:start-8 md:h-10 md:w-32">
            <Image
              src="/marketing/martini-logo.png"
              // eslint-disable-next-line i18next/no-literal-string -- brand name, matches the marketing layout
              alt="Martini Logo"
              width={128}
              height={40}
              className="h-9 w-auto md:h-10"
              priority
            />
          </div>

          <LocaleSwitcher variant="dropdown" className="fixed end-6 top-6 z-50 md:end-8" />

          <main className="flex flex-1 flex-col">{children}</main>
        </div>
      </LocaleAccessGate>
    </Providers>
  )
}
